import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { PlatformSupportSessionBanner } from "./PlatformSupportSessionBanner";

import type { RootState } from "@/redux/store";

/**
 * Mounted once at the app root (not inside PlatformOwnerLayout) because a support
 * session spends most of its life inside the ordinary tenant app shell, not the
 * Platform Owner console — the banner must stay visible there, and a session end
 * (Exit click, or a forced exit from axios.ts on an invalid-session 401) must send
 * the restored platform owner back to /platform regardless of which shell they were
 * in when it happened.
 */
export function PlatformSupportSessionWatcher() {
  const navigate = useNavigate();
  const platformSessionActive = useSelector(
    (state: RootState) => state.platformSession.active,
  );
  const wasActive = useRef(platformSessionActive);

  useEffect(() => {
    if (wasActive.current && !platformSessionActive) {
      navigate("/platform");
    }
    wasActive.current = platformSessionActive;
  }, [platformSessionActive, navigate]);

  return <PlatformSupportSessionBanner />;
}
